// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"f19b73d1","615":"a247b985","847":"495c5be6","884":"1c1f8655","911":"05bdfe5f","991":"50eebd30"}[chunkId] + ".chunk.css";
};